module.exports = __webpack_public_path__ + "img/haft-poznan-06.b6e06f95.jpg";